import { store } from '../store.js';

export const QuickConfigModal = {
    render() {
        if (document.getElementById('quickConfigModal')) return;
        const html = `
        <div id="quickConfigModal" class="modal hidden">
            <div class="modal-content" style="max-width: 500px; padding: 2.5rem; text-align: center; border-radius: 24px;">
                <div style="width: 100%; display: flex; justify-content: flex-start; margin-bottom: 20px;">
                    <button class="btn-atras-unificado" id="qc-close-btn">⬅️ ATRÁS</button>
                </div>
                <h2 style="font-size: 1.8rem; margin-bottom: 0.5rem; color: #1e293b;">Ajustes de Aventura</h2>
                <p style="color: #64748b; margin-bottom: 2rem; font-size: 1rem;">(Opcional) Elige lo que quieras repasar</p>
                
                <div style="display: flex; flex-direction: column; gap: 1.5rem; text-align: left; margin-bottom: 2.5rem;">
                    <div>
                        <label style="display: block; font-weight: bold; margin-bottom: 0.5rem; color: #334155;">➗ Operación</label>
                        <select id="qc-op" class="form-control" style="width: 100%; padding: 0.8rem; border-radius: 12px; border: 2px solid #e2e8f0; font-size: 1.1rem; background-color: #f8fafc; cursor: pointer;">
                            <option value="any">🎲 Cualquiera (Sorpresa)</option>
                            <option value="suma">➕ Sumas</option>
                            <option value="resta">➖ Restas</option>
                        </select>
                    </div>
                    <div>
                        <label style="display: block; font-weight: bold; margin-bottom: 0.5rem; color: #334155;">⭐ Dificultad</label>
                        <select id="qc-diff" class="form-control" style="width: 100%; padding: 0.8rem; border-radius: 12px; border: 2px solid #e2e8f0; font-size: 1.1rem; background-color: #f8fafc; cursor: pointer;">
                            <option value="any">🎲 Cualquiera (Sorpresa)</option>
                            <option value="beginner">🟢 Aprendiz (Nivel 1)</option>
                            <option value="advanced">🟠 Avanzado (Nivel 2)</option>
                            <option value="expert">🔴 Experto (Nivel 3)</option>
                        </select>
                    </div>
                    <div>
                        <label style="display: block; font-weight: bold; margin-bottom: 0.5rem; color: #334155;">🗺️ Contexto</label>
                        <select id="qc-ctx" class="form-control" style="width: 100%; padding: 0.8rem; border-radius: 12px; border: 2px solid #e2e8f0; font-size: 1.1rem; background-color: #f8fafc; cursor: pointer;">
                            <option value="any">🎲 Cualquiera (Sorpresa)</option>
                            <!-- Dynamic options inserted here -->
                        </select>
                    </div>
                </div>
                
                <button id="qc-continue-btn" class="btn btn-primary" style="width: 100%; padding: 1rem; font-size: 1.4rem; border-radius: 16px; background: linear-gradient(135deg, #10B981, #059669); box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4); border: none; color: white; cursor: pointer; transition: transform 0.2s;">
                    ▶️ CONTINUAR
                </button>
                <div id="qc-toast" class="hidden" style="margin-top: 1.5rem; color: #0ea5e9; font-weight: bold; font-size: 1.2rem; background: #e0f2fe; padding: 10px; border-radius: 12px; animation: pulse 1s infinite;"></div>
            </div>
        </div>`;
        document.body.insertAdjacentHTML('beforeend', html);
        
        // Populate dynamic contexts
        const ctxSelect = document.getElementById('qc-ctx');
        if (window.CONTEXTS && window.CONTEXTS.length > 0) {
            window.CONTEXTS.forEach(ctx => {
                const opt = document.createElement('option');
                opt.value = ctx.id;
                const titleText = typeof ctx.title === 'string' 
                    ? ctx.title 
                    : (ctx.title?.['es-ES'] || ctx.title?.['en-GB'] || ctx.id);
                opt.textContent = `${ctx.icon || '📌'} ${titleText}`;
                ctxSelect.appendChild(opt);
            });
        } else {
            // Fallback
            const fallbacks = [
                {id: 'cumpleanos', text: '🎈 Fiesta de Cumpleaños'},
                {id: 'fruteria', text: '🍎 Frutería de Barrio'},
                {id: 'parque', text: '🌳 El Parque'},
                {id: 'colegio', text: '🏫 El Colegio'}
            ];
            fallbacks.forEach(f => {
                const opt = document.createElement('option');
                opt.value = f.id;
                opt.textContent = f.text;
                ctxSelect.appendChild(opt);
            });
        }
        
        document.getElementById('qc-close-btn').addEventListener('click', () => this.close());
        document.getElementById('qc-continue-btn').addEventListener('click', () => this.submit());
        
        // Escape key listener
        this._handleKeyDown = (e) => {
            if (e.key === 'Escape') this.close();
        };
    },

    open() {
        this.render();
        // Reset to ANY
        document.getElementById('qc-op').value = 'any';
        document.getElementById('qc-diff').value = 'any';
        document.getElementById('qc-ctx').value = 'any';
        document.getElementById('qc-toast').classList.add('hidden');
        document.getElementById('qc-continue-btn').disabled = false;
        
        document.getElementById('quickConfigModal').classList.remove('hidden');
        document.addEventListener('keydown', this._handleKeyDown);

        if (window.AccessibilityManager) {
            window.AccessibilityManager.trapFocus(document.getElementById('quickConfigModal'));
            window.AccessibilityManager.announce("Modal de ajustes rápidos abierto. Selecciona tus opciones o pulsa Continuar para una aventura aleatoria.");
        }
    },

    close() {
        const modal = document.getElementById('quickConfigModal');
        if (modal) modal.classList.add('hidden');
        document.removeEventListener('keydown', this._handleKeyDown);
    },

    async submit() {
        const btn = document.getElementById('qc-continue-btn');
        btn.disabled = true;

        const op = document.getElementById('qc-op').value;
        const diff = document.getElementById('qc-diff').value;
        const ctx = document.getElementById('qc-ctx').value;
        
        store.config.problemType = op;
        const diffLevels = ['beginner', 'advanced', 'expert'];
        store.config.level = diff === 'any' ? diffLevels[Math.floor(Math.random() * diffLevels.length)] : diff;
        
        if (ctx === 'any') {
            let safeContexts = ['cumpleanos', 'fruteria', 'parque', 'colegio'];
            if (window.CONTEXTS && window.CONTEXTS.length > 0) {
                safeContexts = window.CONTEXTS.map(c => c.id);
            }
            store.config.context = safeContexts[Math.floor(Math.random() * safeContexts.length)];
            store.config.contextExplicit = false; // context was randomly assigned
        } else {
            store.config.context = ctx;
            store.config.contextExplicit = true; // user explicitly chose a context
        }
        
        const isTotalRandom = op === 'any' && diff === 'any' && ctx === 'any';
        const isPartialRandom = op === 'any' || diff === 'any' || ctx === 'any';
        
        const toast = document.getElementById('qc-toast');
        if (isTotalRandom) {
            toast.textContent = "🎲 ¡Aventura Aleatoria! Preparando problemas sorpresa...";
        } else if (isPartialRandom) {
            toast.textContent = "🎲 ¡Aventura Mixta! Seleccionando elementos al azar...";
        } else {
            toast.textContent = "🚀 ¡Preparando tu aventura!...";
        }
        
        toast.classList.remove('hidden');
        if (window.AccessibilityManager) window.AccessibilityManager.announce(toast.textContent);
        
        // Wait briefly so user sees the message
        await new Promise(r => setTimeout(r, 1200));
        
        // Ensure guest login if not already logged in
        if (window.UserManager && !window.UserManager.isLoggedIn()) {
            window.UserManager.loginGuest();
            if (window.LoginScreen && window.LoginScreen.initGlobalServices) {
                window.LoginScreen.initGlobalServices();
            } else {
                if (window.GamificationService && !window.GamificationService.currentProgress) window.GamificationService.init();
                if (window.StickerStore) window.StickerStore.loadInventory();
                if (window.DetectiveMentor) window.DetectiveMentor.init();
            }
        }
        
        this.close();
        
        // Start game
        if (window.finishConfiguration) {
            window.finishConfiguration();
        } else {
            console.error('finishConfiguration no está disponible.');
        }
    }
};

if (typeof window !== 'undefined') {
    window.QuickConfigModal = QuickConfigModal;
}
